module.exports = __webpack_public_path__ + "static/media/BlueBlockLeftSideEndState.91c6a5bc.svg";